import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { getHotelInfoTitle, getStoreName } from "../../utils/util";

import {
  ContentCardDataType,
  ContentCardDetailType,
  InterphoneCardType,
} from "../../controller/MasterController";
import { authStoreType, masterStoreState } from "../../recoil/auth";
import ApiController from "../../controller/ApiController";
import { visibleCardState } from "../../recoil/modal";

const CardContentModal = (oProps: {
  cardData: ContentCardDataType | InterphoneCardType | null;
  resetTimer?: any;
  type: "main" | "interphone";
}) => {
  const [isVisible, setVisible] = useRecoilState<boolean>(visibleCardState);

  const [lang, setLang] = useRecoilState<number>(langState);
  const master = useRecoilValue<authStoreType | null>(masterStoreState);

  const [cardDetail, setCardDetail] = useState<ContentCardDetailType | null>(
    null
  );

  const onCloseModal = () => {
    setVisible(false);
  };

  // API
  // 카드 상세정보 불러오기
  const getCardContent = async (cardId: number) => {
    try {
      const response = await ApiController.store.getCardContent(cardId, lang);

      if (response.ok) {
        setCardDetail(response.data);
      }
    } catch (err) {
      console.log("getCardContent err-->", err);
    }
  };

  useEffect(() => {
    if (isVisible && oProps.cardData) {
      getCardContent(oProps.cardData.card_id);
    } else {
      setCardDetail(null);
    }
  }, [isVisible]);

  if (!oProps.cardData || !cardDetail) return null;

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: "cardContentModal",
        overlay: "cardContentModalOverlay",
      }}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
    >
      <Style>
        <div
          className="modal"
          onTouchStart={oProps.resetTimer}
          onScrollCapture={oProps.resetTimer}
        >
          {master && (
            <div className="header">
              <h2>{getStoreName(master, lang)}</h2>
              <h1>
                {oProps.type === "main"
                  ? getHotelInfoTitle(
                      oProps.cardData as ContentCardDataType,
                      lang
                    )
                  : (oProps.cardData.title as string)}
              </h1>
              <div className="bar" />
            </div>
          )}
          <img
            className="closeIcon"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
            alt="ic"
            onClick={onCloseModal}
          />
          <div className="modalContentWrap">
            {cardDetail &&
              cardDetail.content_data.map((item, idx) => (
                <div className="contentWrap" key={idx}>
                  {item.content_type === 0 ? (
                    <img src={item.url} alt="호텔소개 이미지" />
                  ) : (
                    <p>{item.content}</p>
                  )}
                </div>
              ))}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CardContentModal;

const Style = styled.div`
  .modal {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    height: 98vh;
    text-align: center;
  }
  .header {
    padding: 40px 0;
    text-align: center;
    top: 0;

    h2 {
      font-size: 28px;
      line-height: 40px;
      font-weight: 300;
      color: #ffffff;
    }
    h1 {
      font-size: 36px;
      line-height: 50px;
      font-weight: 600;
      color: #ffffff;
    }
    .bar {
      margin: 0 auto;
      margin-top: 40px;
      width: 50px;
      height: 4px;
      background: #4dd2ae;
    }
  }
  .closeIcon {
    position: absolute;
    left: 2%;
    top: 1.5%;
  }
  /* modalContentWrap */
  .modalContentWrap {
    width: 100%;
    height: 100%;
    overflow-y: auto !important;
    margin-bottom: 40px;

    img {
      width: 100%;
      margin-bottom: 12px;
      object-fit: contain;

      padding: 0 20px;
    }
    p {
      margin-bottom: 12px;
      padding: 0 20px;
      font-size: 18px;
      font-weight: 300;
      line-height: 28px;
      text-align: left;
    }
  }
`;
